export default __webpack_public_path__ + "static/media/idx2.23620e41.png";